/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Product_Id_InvalidInputs */

const vi_validation_product_id_invalid = /** @type {(inputs: Validation_Product_Id_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sản phẩm không hợp lệ`)
};

/**

* @param {Validation_Product_Id_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const validation_product_id_invalid = /** @type {((inputs?: Validation_Product_Id_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Product_Id_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_validation_product_id_invalid(inputs)
});